<template>
  <div class="full-height">
    <div v-if="clientPortal.portal == '3'" class="full-height">
      <v-card class="pa-0 full-height" id="card-config-preview">
        <v-card-text class="pa-0 full-height">
          <v-container fluid class="full-height pa-0">
            <v-row class="full-height" no-gutters>
              <v-col cols="12" md="8" class="border-right relative full-height">
                <div class="text-center full-height">
                  <iframe
                    :src="previewUrl"
                    style="
                      width: 100%;
                      max-width: 400px;
                      height: calc(100% - 16px);
                      overflow: auto;
                    "
                    class="mt-2"
                    v-if="portalHasNas && clientPortal.portal === 3"
                  />
                  <div v-else>
                    Le portail n'a pas de NAS actif et/ou n'est pas en V5
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="4" class="pa-0 full-height">
                <v-row no-gutters class="full-height">
                  <v-col cols="12" class="pa-0" id="model-title">
                    <v-card
                      class="pa-0"
                      flat
                      @click="openPresentationDialogIfInherit"
                    >
                      <v-card-title>
                        <div v-if="clientPortal.isInherit">
                          <div>
                            Héritage :
                            {{ clientPortal.group.description }}
                          </div>
                          <div>
                            <span
                              >Modèle :
                              {{ clientPortal.group.portalName }}</span
                            >
                          </div>
                        </div>
                        <div v-else-if="clientPortal.isBuiltin">
                          Template :
                          {{ clientPortal.portalOptions.name }}
                        </div>
                        <div v-else>
                          <span>Modèle : {{ clientPortal.portalName }}</span>
                        </div>
                      </v-card-title>
                    </v-card>
                    <v-divider></v-divider>
                  </v-col>
                  <div
                    v-if="
                      clientPortal.portalConfigurationModel
                        .basic_presentation != null &&
                      clientPortal.portalConfigurationModel.full_presentation !=
                        null
                    "
                    class="pa-0 thin-scroll overflow-y"
                    :style="
                      'height: calc(100% - ' + configScrollHeightOffset + 'px)'
                    "
                  >
                    <portal-configuration-presentation-settings
                      :isInherit="clientPortal.isInherit"
                      :isBuiltIn="clientPortal.isBuiltin"
                      :isGroup="clientPortal.group != null"
                      :id="String(clientPortal.id)"
                      :portalConfigurationModel="
                        clientPortal.portalConfigurationModel
                      "
                      :group="clientPortal.group"
                      :partner="clientPortal.partner"
                      :portalConfiguration.sync="
                        clientPortal.portalConfiguration
                      "
                      :rules="rules"
                      v-on:mounted="computeConfigScrollOffset"
                      ref="editSettings"
                      @update:portal-settings="updatePortalSettingsTab"
                      :loadingSettingsPortal="loadingSettingsPortal"
                    ></portal-configuration-presentation-settings>
                  </div>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </div>
    <div v-else>
      <v-alert type="warning">
        Il faut migrer le portail pour pouvoir le configurer.
      </v-alert>
    </div>
  </div>
</template>
<script>
import {
  defineComponent,
  computed,
  watch,
  ref,
  toRefs,
} from "@vue/composition-api";
import { useClientPortal } from "@/composables/client-portal";
import PortalConfigurationPresentationSettings from "@/components/PortalConfiguration/PortalConfigurationPresentationSettings.vue";
import { useIframePreview } from "@/composables/iframe-preview";
import { useRoles } from "../../composables/roles";

export default defineComponent({
  components: {
    PortalConfigurationPresentationSettings,
  },
  props: {
    clientPortal: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    /* import des API */
    const {
      data,

      updatePortalConfigurationSparse,
    } = useClientPortal();
    const { isGrantedUser } = useRoles();

    /* Variables */
    const editSettings = ref(null);
    const baseUrl = config.VUE_APP_API_PUBLIC;
    const loadingSettingsPortal = ref(false);
    const configScrollHeightOffset = ref(0);
    const configurationformData = ref({});

    /* Computed */
    const portalHasNas = computed(function () {
      if (props.clientPortal && props.clientPortal.firstNas) {
        return true;
      } else {
        return false;
      }
    });
    const previewUrl = computed(function () {
      let value = "";

      if (props.clientPortal && props.clientPortal.firstNas) {
        value = `${baseUrl}login-url.php?id=${props.clientPortal.firstNas.nasIdentifier}`;
      }

      return value;
    });

    const { reloadPreview } = useIframePreview();

    const openPresentationDialogIfInherit = function () {
      if (!props.clientPortal.isInherit) {
        data.portalPresentationModelDialog = true;
      }
    };
    const updatePortalSettingsTab = async function () {
      loadingSettingsPortal.value = true;
      configurationformData.value = {
        user_form: props.clientPortal.portalConfiguration.user_form,
        basic_presentation:
          props.clientPortal.portalConfiguration.basic_presentation,
        full_presentation:
          props.clientPortal.portalConfiguration.full_presentation,
        has_card_at_reception:
          props.clientPortal.portalConfiguration.has_card_at_reception,
        has_pms_marseo: props.clientPortal.portalConfiguration.has_pms_marseo,
        hide_access_codes:
          props.clientPortal.portalConfiguration.hide_access_codes,
        hide_free_access_codes:
          props.clientPortal.portalConfiguration.hide_free_access_codes,
        ad: props.clientPortal.portalConfiguration.ad,
        is_luxury: props.clientPortal.portalConfiguration.is_luxury,
        brand_newsletter:
          props.clientPortal.portalConfiguration.brand_newsletter,
      };
      await updatePortalConfigurationSparse(
        String(props.clientPortal.id),
        configurationformData.value
      );
      loadingSettingsPortal.value = false;
      reloadPreview();
    };
    const computeConfigScrollOffset = function () {
      const modelTitleElement = document.getElementById("model-title");
      if (modelTitleElement) {
        setTimeout(function () {
          configScrollHeightOffset.value = modelTitleElement.clientHeight + 36; //36 = hauteur du bouton enregistrer
        }, 0);
      }
    };

    watch(
      () => [
        data.portalPresentationModelDialog,
        data.portalPresentationOtherDialog,
      ],
      (newValues, oldValues) => {
        if (
          (!newValues[0] && oldValues[0]) ||
          (!newValues[1] && oldValues[1])
        ) {
          reloadPreview();
        }
      }
    );

    return {
      openPresentationDialogIfInherit,
      portalHasNas,
      previewUrl,
      updatePortalSettingsTab,
      computeConfigScrollOffset,
      editSettings,
      loadingSettingsPortal,
      configScrollHeightOffset,
      ...toRefs(data),
      isGrantedUser,
    };
  },
});
</script>
